import React from 'react';
import { Link } from 'react-router-dom';

const ArticleBodySection = ({ articleHtml, contentRef, status }) => {
  return (
    <div className="site-bg-section py-20 px-6">
      <div className="container mx-auto max-w-3xl">
        {status === 'loading' && <p className="text-center text-gray-600">Carregando artigo...</p>}
        {status === 'error' && (
          <div className="bg-white p-8 rounded-lg border border-gray-200 shadow-lg site-card text-center">
            <p className="text-lg text-gray-600">Nao foi possivel encontrar este artigo.</p>
            <div className="mt-6">
              <Link to="/blog/artigos" className="text-blue-600 font-semibold hover:underline">
                Voltar para a lista de artigos
              </Link>
            </div>
          </div>
        )}
        {status === 'success' && (
          <div className="article-reading-panel site-card">
            <p className="article-reading-eyebrow">Conteudo do artigo</p>
            <div className="article-content" ref={contentRef}>
              <div dangerouslySetInnerHTML={{ __html: articleHtml }} />
            </div>
          </div>
        )}
        {status === 'success' && (
          <div className="mt-12 border-t border-gray-200 pt-6 flex items-center justify-between text-sm text-gray-600">
            <Link to="/blog/artigos" className="text-blue-600 hover:underline">
              &larr; Voltar para os artigos
            </Link>
            <a
              href="https://github.com/GuilhermePortella"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              Ver GitHub
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default ArticleBodySection;
